import { SideImage } from '../../components/SideImage';
import { PackageDiningContentPanel } from '../../composites/PackageDiningContentPanel';
import { SplitLayout } from '../../composites/SplitLayout';
import type { PackageDiningTemplateProps } from './PackageDiningTemplate.types';

export function PackageDiningTemplate({
  imageUrl,
  imageAlt = '',
  ...panelProps
}: PackageDiningTemplateProps) {
  return (
    <SplitLayout
      leftWidth="45%"
      contentMaxWidth="660px"
      height="var(--layout-viewport-height, 100vh)"
      left={<SideImage src={imageUrl ?? undefined} alt={imageAlt} sticky />}
      right={<PackageDiningContentPanel {...panelProps} />}
    />
  );
}
